export interface ContactModel {
  id: number,
  title: string | null,
  gender: string | null,
  firstName: string | null,
  lastName: string | null,
  companyName: string | null,
  zipCode: string | null,
  city: string | null,
  street: string | null,
  phoneNumber: string | null,
  phoneNumbers: PhoneNumbersEntry[] | null,
  mobilePhoneNumber: string | null,
  mobilePhoneNumberName: string | null,
  mobilePhoneNumber2: string | null,
  mobilePhoneNumber2Name: string | null,
  url: string | null,
  email: string | null,
  type?: string,
  idCardNumber: string | null,
  birthday: Date | null | string,
  birthPlace: string | null,
  competentAuthority?: {
    id: number
  } | null,
  noNewAnimal: boolean | null,
  /** Tierarzt bzw. Tierarztpraxis — kein eigener Kontakttyp, `type` beschreibt die Rechtsform. */
  isVeterinary?: boolean,
}

export interface MergeContactPayload {
  primaryContact: ContactModel;
  otherContacts: ContactModel[];
  mergedContact: Partial<ContactModel>;
  conflictingFields: Partial<Record<keyof ContactModel, any[]>>;
}

export interface PhoneNumbersEntry {
  id?: number,
  number: string | null,
  type: PhoneNumbersEntryType,
  label: string | null,
  isPrimary: boolean
}

export enum PhoneNumbersEntryType {
  PRIVATE = 'private',
  MOBILE = 'mobile',
  BUSINESS = 'business',
  CUSTOM = 'custom'
}